import { Select } from "antd";
import SelectBaseAntd, {
  SelectBaseAntdProps,
} from "ui/components/Input/SelectBaseAntd";

const { Option } = Select;

export interface SelectTipoParticipanteProps extends SelectBaseAntdProps {
  value: any;
  onChange: (v: any) => void;
  valueTrue?: string | number;
  valueFalse?: string | number;
}

export enum SelectBooleanoDefaultValues {
  True = "s",
  False = "n",
}

function SelectBooleano({
  value,
  onChange,
  valueTrue = SelectBooleanoDefaultValues.True,
  valueFalse = SelectBooleanoDefaultValues.False,
  ...rest
}: SelectTipoParticipanteProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      style={{ width: "100%" }}
      value={value}
      onChange={(ev) => {
        onChange(ev);
      }}
      {...rest}
    >
      <Option value={valueTrue} key={valueTrue}>
        Sim
      </Option>
      <Option value={valueFalse} key={valueFalse}>
        Não
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectBooleano;
